import './App.css';
import { BrowserRouter, Route, Routes, Navigate, useLocation } from "react-router-dom";
import React, { useState }from 'react';
import { withTranslation } from 'react-i18next';

import Restaurants from './components/Pages/Restaurants';
import Home from './components/Pages/Home';
import Incident from './components/Pages/Incident';
import NewIncident from './components/Pages/Incident/NewIncident';
import Knowledge from './components/Pages/Knowledge/KBCategories';
import Announcements from './components/Pages/Announcements';
import Dashboard from './components/Pages/Dashboard';
import Header from './components/Layout/Header';
import Login from './components/Pages/Login';
import NewRFM from './components/Pages/Incident/NewRFM';
import NewCAP from './components/Pages/Incident/NewCAP';
import KBArticles from './components/Pages/Knowledge/KBArticles';
import KBArticle from './components/Pages/Knowledge/KBArticle';
import Settings from './components/Pages/Settings';
import Widget from './components/Layout/Widget';
import RestaurantsHome from './components/Pages/RestaurantsHome';
import Auth from './components/Pages/Auth';
import { Amplify } from 'aws-amplify';

function App() {
  /* AWS Cognito Init */
  Amplify.configure({
    Auth: {
      region: process.env.REACT_APP_COGNITO_REGION,
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
      userPoolWebClientId: process.env.REACT_APP_COGNITO_WEB_CLIENT_ID,
      oauth: {
        domain: process.env.REACT_APP_COGNITO_OAUTH_DOMAIN,
        scope: ['email', 'openid', 'phone'],
        redirectSignIn: process.env.REACT_APP_COGNITO_OAUTH_REDIRECT_LINK,
        redirectSignOut: process.env.REACT_APP_COGNITO_OAUTH_REDIRECT_LINK,
        responseType: 'code'
      }
    }
  });

  const RequireAuth = ({ children }) => {
    const identifier = localStorage.getItem("user_identifier");
    const authed = identifier !== null && identifier !== "";
    const location = useLocation();
    if(!localStorage.getItem("language")) {
      localStorage.setItem("language", "en");
    }
    return authed ? (children) : (<Navigate to="/auth" replace state={{ path: location.pathname }} />);
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Header/>

        <Routes>
          <Route path="/login" element={ <Login />}/>
          <Route path="/auth" element={ <Auth />}/>

          <Route path="/" element={<RequireAuth> <Home /> </RequireAuth>}/>
          <Route path="/home" element={<RequireAuth> <Home /> </RequireAuth>}/>
          <Route path="/search" element={<RequireAuth> <RestaurantsHome /> </RequireAuth>} />
          <Route path="/restaurants" element={<RequireAuth> <Restaurants /> </RequireAuth>} />
          <Route path="/announcements" element={<RequireAuth> <Announcements /> </RequireAuth>} />
          <Route path="/dashboard" element={<RequireAuth> <Dashboard /> </RequireAuth>} />
          <Route path="/incident" element={<RequireAuth> <Incident /> </RequireAuth>} />
          <Route path="/new_incident" element={<RequireAuth> <NewIncident /> </RequireAuth>} />
          <Route path="/new_rfm" element={<RequireAuth> <NewRFM /> </RequireAuth>} />
          <Route path="/new_cap" element={<RequireAuth> <NewCAP /> </RequireAuth>} />
          <Route path='/settings' element={<RequireAuth> <Settings/> </RequireAuth>} />

          <Route path="/knowledge" element={<RequireAuth> <Knowledge /> </RequireAuth>}/>
          <Route path="/knowledge/articles" element={<RequireAuth> <KBArticles /> </RequireAuth>} />
          <Route path="/knowledge/article" element={<RequireAuth> <KBArticle /> </RequireAuth>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;